/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.09.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';
import _at from 'lodash/at';
import _size from 'lodash/size';
import _chunk from 'lodash/chunk';
import _isEqual from 'lodash/isEqual';

import {FetchAssetByIds} from '../../actions/asset/action-asset';
import {OpenProfileFor} from '../../actions/common/actions-common';

import Translate from '../../components/Translate';
import DivLoader from '../../components/DivLoader';
import ShowcaseRow from '../../components/ShowcaseCollection/showcase-collection-row';

class ShowcaseFavorites extends Component {
  constructor(props) {
    super(props);

    this.state = {
      extendedRow: null,
      extendedCol: null
    };
  }

  componentDidMount() {

    this.props.FetchAssetByIds(this.props.favorites);

    if (this.props.globalProfile && this.props.globalProfile !== 'favorites') {

      this._onCollapseRow();
    }
  }

  componentWillReceiveProps(newProps) {

    if (!_isEqual(newProps.favorites, this.props.favorites)) {

      this.props.FetchAssetByIds(newProps.favorites);

      this._onCollapseRow();
    }

    if (newProps.globalProfile && newProps.globalProfile !== 'favorites') {

      this._onCollapseRow();
    }
  }

  _onExtendRow(row, col) {

    this.setState({extendedRow: row, extendedCol: col});
    this.props.OpenProfileFor('favorites');
  }

  _onCollapseRow() {

    this.setState({extendedRow: null, extendedCol: null});
  }

  _renderAssetRows() {
    if (!_size(this.props, 'assets')) {
      return null;
    }

    return _chunk(this.props.assets, '9').map((chunk, index) => {
      return <ShowcaseRow
        key={`row_${index}`}
        assets={chunk}
        row={index}
        onExtendRow={this._onExtendRow.bind(this)}
        isExtend={this.state.extendedRow === index}
        sel_row={this.state.extendedRow}
        sel_col={this.state.extendedCol}
      />
    });
  }

  render() {

    return (
      <div className="asset-showcase" style={{position: 'relative'}}>
        <div id="showcase-header" className="blocks-row clearfix">
          <ul className="menu block-3 radius bg-black">
            <li className="block-1">
              <a className="pad-lr hover pointer">
                <span className="icon">
                   <i className="ic ic-fav-in-fill ic-24px" style={{position: 'relative', top: '14px'}}></i>
                </span>
              </a>
            </li>
            <li className="block-1">
              <a className="pad-lr hover container pointer">
                <span> <strong> <Translate content='favorites' /> </strong></span>
              </a>
            </li>
          </ul>
        </div>
        <div id="showcase-row-container">
          {this._renderAssetRows()}
        </div>
        { (this.props.inProgress) &&
        <div className="profile-container">
          <div id="showcase_row" style={{height: '132px', position: 'relative'}}>
            <div className="blocks-row clearfix showcase-row radius" style={{height: '100%'}}>
              <DivLoader loading={this.props.inProgress} />
            </div>
          </div>
        </div>
        }
        { (!this.props.inProgress && !_size(this.props.assets) ) && <div id="showcase-empty-container">
          <div className="ui dimmer visible active radius">
            <div className="content">
              <div className="center">
                <h2 className="ui inverted icon header">
                  <Translate content="empty_section" />
                </h2>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    );
  }
}

ShowcaseFavorites.propTypes = {
  /**
   * @connect props
   */
  assets: PropTypes.array.isRequired,
};

ShowcaseFavorites.defaultProps = {
  /**
   * @connect props
   */
  assets: []
};

const mapStateToProps = ({assets, favorites: {favorites}, common: {profile}}) => {
  let collection = _get(favorites, 'collection', []);
  let assetEntities = _at(assets, collection);

  return {
    globalProfile: profile,
    assets: assetEntities,
    favorites: collection,
    inProgress: !!favorites.inProgress
  }
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({FetchAssetByIds, OpenProfileFor}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowcaseFavorites);



// WEBPACK FOOTER //
// ./src/containers/ShowcaseFavorites/showcase-favorites.js